const data = {};

data.first_name = require("./first_name")
data.last_name = require("./last_name")
data.domains = require('./domains')
data.phone = require('./phone')
data.tribe = require('./tribe')
data.job = require('./job')
data.bank = require('./bank')
data.company = require('./company')
data.color = require('./color')
data.food = require('./food')

module.exports = data